import { OptionKV } from "~styled/selector/Selector";

const TODOS = "";
export const SANCOR = "Sancor";
export const BERKLEY = "Berkley";
export const ZURICH = "Zurich";
export const TRIUNFO = "Triunfo";
export const RUS = "RUS";
export const MERCANTIL_ANDINA = "MercantilAndina";
export const MAPFRE = "Mapfre";
export const PARANA = "Parana";

const companiasSegurosOptions: Record<string, string> = {
  [TODOS]: "Todos",
  [SANCOR]: "Sancor",
  [BERKLEY]: "Berkley",
  [ZURICH]: "Zurich",
  [TRIUNFO]: "Triunfo",
  [RUS]: "Río Uruguay Seguros",
  [MERCANTIL_ANDINA]: "Mercantil Andina",
  [MAPFRE]: "Mapfre",
  [PARANA]: "Paraná",
};

const companiasFilter: OptionKV<string>[] = [
  { label: companiasSegurosOptions[TODOS], value: TODOS },
  { label: companiasSegurosOptions[SANCOR], value: SANCOR },
  { label: companiasSegurosOptions[BERKLEY], value: BERKLEY },
  { label: companiasSegurosOptions[ZURICH], value: ZURICH },
  { label: companiasSegurosOptions[TRIUNFO], value: TRIUNFO },
  { label: companiasSegurosOptions[RUS], value: RUS },
  { label: companiasSegurosOptions[MERCANTIL_ANDINA], value: MERCANTIL_ANDINA },
  { label: companiasSegurosOptions[MAPFRE], value: MAPFRE },
  { label: companiasSegurosOptions[PARANA], value: PARANA },
];

export { companiasSegurosOptions, companiasFilter };
